<template>
  <div class="modal notification-modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog-centered modal-base">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">파일 업로드</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
            <div class="info-div" style="overflow-x:auto;">

                <table class="info-table">

                    <tr>
                      <td colspan="2">
                        <input type="file" class="form-control" accept=".csv"  @change="selectedFile($event)">
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="ezFileupload">업로드</button>
                        <button class="btn btn-success btn-sm" @click="downloadCsv('sample')">양식 다운로드</button>
                      </td>
                    </tr>
                    <colgroup>
                        <col width="20%">
                        <col width="50%">
                        <col width="*">
                    </colgroup>
                    <tbody>

                        <tr>
                          <th>성공여부</th>
                          <th>원인</th>
                          <th>시간</th>
                        </tr>
                        <tr>
                          <td>{{resultData.result }}</td>
                          <td>{{resultData.status }}</td>
                          <td>{{resultData.uploadDate }}</td>
                          <td hidden="true">{{resultData.id }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
          
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, ref} from "vue";
import {useStore} from "vuex";
import axios from "@/composables/Axios";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";
import dayjs from "dayjs";
const url = tachoEntity.baseUrl;
const store = useStore();
const operationUrl = store.state['api'].operationUrl;
const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
const header = entity.get();

const props = defineProps({
  regionList: Object,
})
const downloadTF = ref(true);
const fileName = ref("");
const resultData = ref({status:"",result:"",uploadDate:"",id:-1});

const emit = defineEmits(['close', 'refreash']);

const selectedFile = (e) => {
  //파일 선택
  if (e.target.files[0] && e.target.files[0].type !== "text/csv"){    // 확장자 체크
    alert("csv 파일만 업로드가 가능합니다.");
    fileName.value = "";
    emit('close');
    return;
  }
  let uploadData = e.target.files[0].name.split('.csv');
  if (uploadData.length == 0 ){                                       // 파일명 유효성 체크
    alert("파일명을 확인해주세요.");
    fileName.value = "";
    emit('close');
    return;
  }
  let uploadName = uploadData[0];
  const nameRex = /^[ㄱ-ㅎ가-힣a-zA-Z0-9_]+$/;
  if (uploadName && !nameRex.test(uploadName)){                          // 파일명 내용 체크
    alert("숫자, 한글, 영문, 특수문자(_)외 파일명은 업로드가 불가합니다.");
    fileName.value = "";
    emit('close');
    return;
  }

  fileName.value = e.target.files[0];
}
const ezFileupload = async () => {
  //업로드
  await validate(fileName.value);
}

const validate = async (file) => {
    if(!file){
      downloadTF.value = true;
      resultData.value = "";
      return;
    }
    try {
    let header = entity.get();
    header['Content-Type'] = 'multipart/form-data';

    const formData = new FormData();
    formData.append("file",file);
    formData.append("user_id",entity.user_id);
    formData.append("trace_id",entity.trace_id);

    resultData.value.uploadDate =  dayjs().format("YYYY-MM-DD HH:mm:ss");

    const res = await axios.$post(`${url}ezl/upload`, formData, {headers: header});
    resultData.value.result = "성공";
    resultData.value.status = "";
    downloadTF.value = false;
  } catch (error) {
      resultData.value.result = "실패"
      downloadTF.value = true;
      resultData.value.status = error.response.data.message;

  }
}

const downloadCsv = async (downloadType) => {

  if(downloadType && downloadType.id == -1){
    return;
  }
  try {
    let headers = entity.get();

    let downloadUrl = `${url}ezl/download-sample`;

    if(downloadType != "sample"){
      downloadUrl = `${url}ezl/download-res/${downloadType.id}`;   //zip 파일
    }

    let downloadFile = await axios.$get(downloadUrl, {
      responseType: 'blob'
    }, headers);

    let blob = new Blob([downloadFile.data], {type: downloadFile.headers['content-type']});
    let fileName = getFileName(downloadFile.headers['content-disposition']);
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
    link.remove();
  } catch (err) {
    store.commit("openMessageBox", err);
  }
}

const getFileName = (contentDisposition) => {
  let filenameList = contentDisposition.split(';')[1].replace(/"/g, '').split('=');
  let filename = filenameList[1] ? filenameList[1] : "";
  filename = decodeURIComponent(filename);
  return filename;
}
</script>

<style scoped>

</style>